module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xthor5-61167b04389de4be4774f6fa4d1eb2ca.jpg";